import { Component } from "react";
import CircleButton from "../CircleButton";
import {ReactComponent as DeleteIc} from "../../../assets/icons/delete-ic.svg";

class DeleteButton extends Component {    

    render() {
        return (
            <>                
                <CircleButton icon={<DeleteIc/>} />
            </>
        )
    }
}

export default DeleteButton;